import { Button, Grid } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { usaStateListWithCodes } from '../../../data/fhirHumanNameData';
import {
  AutoCompleteWithTopLabel,
  SelectWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../uiComponent/fhirComponentUi';
import { capitalizeFirstLetter, getZipCodes } from '../../../config/common';
import { useDispatch, useSelector } from 'react-redux';
import { useMainFrameDispatch } from '../../MainUIFrame/MainFrame';
import { setProgress } from '../../../redux/features/progressSlice';
import { ehrAPIBaseService, ehrAPIServiceClaim } from '../../../http-common';
import { ACTION_CLOSE_RIGHT_FLOATING_DRAWER } from '../../MainUIFrame/constants';
import jwtDecode from 'jwt-decode';
import { quickAddData } from '../../../redux/features/quickAddDataSlice';
import { GET_COUNTRIES, GET_STATES } from '../../../config/address-helper';
import { generateNotifications } from '../../reusableLogic';
import { useSnackbar } from 'notistack';

const convertNPIObjectToState = ({ npiObject } = {}) => {
  if (!npiObject) return;

  const npiNumber = npiObject?.number;
  const organizationName = npiObject?.basic?.organization_name;
  const workAddressObject = npiObject?.addresses?.filter(
    f => f?.address_purpose === 'LOCATION'
  )?.[0];
  const addressLine1 = workAddressObject?.address_1;
  const addressLine2 = workAddressObject?.address_2;
  const city = workAddressObject?.city;
  const state = usaStateListWithCodes?.filter(
    f => f?.code === workAddressObject?.state
  )?.[0];
  const postalCodeRaw = workAddressObject?.postal_code?.slice(0, 5);
  const postalCode = { code: Number(postalCodeRaw), display: postalCodeRaw };

  const workNumber = workAddressObject?.telephone_number?.replace(/-/g, '');
  const country = workAddressObject?.country_code;

  return {
    npiNumber,
    organizationName,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    country,
    workNumber,
  };
};

const FHIROrganizationQuickAdd = props => {
  const npiObject = props?.npiObject;
  const nmcObject = false;
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  const [organizationState, setOrganizationState] = useState(
    convertNPIObjectToState({ npiObject }, selectedVersion)
  );

  const reduxDispatch = useDispatch();
  const quickData = useSelector(state => state.quickAddData);
  const dispatch = useMainFrameDispatch();
  const workAddressObject = npiObject?.addresses?.filter(
    f => f?.address_purpose === 'LOCATION'
  )?.[0];

  const [originalState, setOriginalState] = useState(
    usaStateListWithCodes?.filter(
      f => f?.code === workAddressObject?.state
    )?.[0]
  );

  const [zipcodeOptions, setZipcodeOptions] = useState([]);
  const [organizationStatesList, setOrganizationStatesList] = useState([]);

  const handleOnChange = event => {
    const { name, value } = event?.target;
    if (name === 'npiNumber') {
      const numericValue = value.replace(/\D/g, '');
      setOrganizationState({ ...organizationState, npiNumber: numericValue });
      return;
    }
    let newValue = value;
    const fieldsToCapitalize = [
      'organizationName',
      'addressLine1',
      'addressLine2',
      'city',
    ];

    if (fieldsToCapitalize.includes(name)) {
      newValue = capitalizeFirstLetter(newValue);
    }

    setOrganizationState({
      ...organizationState,
      [name]: newValue,
    });
  };

  useEffect(() => {
    setZipcodeOptions([
      ...getZipCodes(
        organizationState?.state?.code
          ? organizationState?.state?.code
          : // : usaStateListWithCodes.length
          // ? usaStateListWithCodes[0]?.code
          selectedVersion == 'IN'
          ? 'AN'
          : 'AL',
        // : '',
        organizationState?.country?.slice(0, 2)?.toUpperCase()
      ),
    ]);
    if (organizationState?.state?.code !== originalState?.code) {
      setOrganizationState({ ...organizationState, postalCode: undefined });
      setOriginalState(organizationState?.state);
    }
  }, [organizationState?.state?.code]);

  const organizationNameRef = useRef(null);
  const npiRef = useRef(null);
  const addressLine1Ref = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const postalcodeRef = useRef(null);
  const workNumberRef = useRef(null);
  const emailRef = useRef(null);
  const countryRef = useRef(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [apexArrayList, setApexArrayList] = useState([]);
  const [apexObject, setApexObject] = useState({ code: '', display: '' });

  const listApexPayers = async () => {
    let param = {};
    param.payerType = 'Medical';
    const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
    const tenantId = jwtPayload?.firebase?.tenant;
    try {
      const response = await ehrAPIServiceClaim.get(
        `${tenantId}/getPayers`,
        param
      );
      let value;
      let options = [];
      let nameValue;
      let nameOptions = [];
      let apexArrayList = [];
      response?.data?.map((data, index) => {
        console.log(data);
        value = {
          label: data.ApexPayerId,
          value: data.ApexPayerId,
          apexName: data.Name,
        };
        nameValue = {
          label: data.Name,
          value: data.name,
          apexId: data.ApexPayerId,
        };
        apexArrayList.push({
          code: data.PayerId || data.ApexPayerId,
          display: data.Name,
        });
        options.push(value);
        nameOptions.push(nameValue);
      });

      const sortedApexArrayList = apexArrayList.reduce(
        (accumulator, current) => {
          if (!accumulator.find(item => item.display === current.display)) {
            accumulator.push(current);
          }
          return accumulator;
        },
        []
      );

      // setAPexList(options);
      // setApexNameList(nameOptions);
      setApexArrayList(sortedApexArrayList);
    } catch (error) {
      console.log('listApexPayers error', error);
    }
  };

  useEffect(() => {
    if (props?.isInsurance) {
      listApexPayers();
    }
  }, [props?.isInsurance]);

  const apexNameRef = useRef(null);

  const apexNameAutoCompleteValidationObject = {
    name: 'apexName',
    value: apexObject,
    label: 'Organization Name',
    optionsList: apexArrayList,
    disablePortal: true,
    ref: apexNameRef,
    customErrorText: 'Please select a valid Organization Name',
    validation: {
      required: true,
    },
  };

  const apexPayerIdRef = useRef(null);

  const payerIdAutoCompleteValidationObject = {
    name: 'payerId',
    value: apexObject,
    label: 'Payer Id',
    optionsList: apexArrayList,
    disablePortal: true,
    optionsRender: 'code',
    ref: apexPayerIdRef,
    customErrorText: 'Please select a valid Payer ID',
    validation: {
      required: true,
    },
    // optionsList: [],
  };

  const organizationNameValidationObject = {
    name: 'organizationName',
    value: organizationState?.organizationName,
    label: 'Organization Name',
    validation: {
      required: true,
    },
    ref: organizationNameRef,
  };

  const nmcRef = useRef(null);

  const ValidationObject1 = selectedVersion => {
    let name;
    let value;
    let ref;
    let label;
    let validation;
    let mask;
    let maxLength;

    if (selectedVersion === 'IN') {
      name = 'nmcNumber';
      value = organizationState?.nmcNumber;
      label = props?.isInsurance ? 'Payer Id' : 'NMC Number';
      ref = nmcRef;
      validation = {
        required: true,
        // min: 10,
        // max: 10,
        disabled: nmcObject ? true : false,
      };
      // maxLength = 10;

      // mask = '9999-99-9999';
    } else {
      name = 'npiNumber';
      value = organizationState?.npiNumber;
      label = props?.isInsurance ? 'Payer Id' : 'NPI Number';
      ref = npiRef;
      validation = {
        required: !props?.managingOrg,
        min: 10,
        max: 10,
        disabled: npiObject ? true : false,
      };

      mask = '9999-99-9999';
      maxLength = 10;
    }

    return {
      name,
      value,
      label,
      ref,
      validation,
      mask,
      maxLength,
    };
  };

  const addressLine1ValidationObject = {
    name: 'addressLine1',
    value: organizationState?.addressLine1,
    label: 'Address Line 1',
    validation: {
      required: true,
    },
    ref: addressLine1Ref,
  };

  const addressLine2ValidationObject = {
    name: 'addressLine2',
    value: organizationState?.addressLine2,
    label: 'Address Line 2',
  };

  const cityValidationObject = {
    name: 'city',
    value: organizationState?.city,
    label: selectedVersion === 'IN' ? 'City/District/Village' : 'City',
    ref: cityRef,
    validation: {
      required: true,
    },
  };

  const stateValidationObject = {
    name: 'state',
    value: organizationState?.state || usaStateListWithCodes?.[0],
    // value: organizationState?.state || '',
    label: 'State',
    optionsList: usaStateListWithCodes,
    // optionsList: organizationStatesList,
    validation: {
      required: true,
    },
    ref: stateRef,
  };

  const postalCodeValidationObject = {
    name: 'postalCode',
    value: organizationState?.postalCode || { code: '', display: '' },
    label: 'Zip Code',
    optionsList: zipcodeOptions,
    validation: {
      required: true,
    },
    ref: postalcodeRef,
  };

  const workNumberValidationObject = {
    name: 'workNumber',
    value: organizationState?.workNumber,
    label: 'Business Phone',
    validation: {
      required: true,
      min: 10,
      max: 10,
      pattern: /^[0-9]+$/,
    },
    mask: '(999) 999-9999',
    ref: workNumberRef,
    maxLength: 10,
  };

  const emailValidationObject = {
    name: 'email',
    value: organizationState?.email,
    label: 'Email',
    validation: {
      // required: true,
      // min: 2,
      // max: 500,
      pattern: /^\w+([.+]?\w+)*@\w+([.+]?\w+)*(\.\w{2,3})+$/,
    },
    ref: emailRef,
  };

  const generateOrganizationFHIRObject = () => {
    const addressWork = {
      city: organizationState?.city,
      country:
        organizationState?.country === 'US'
          ? 'USA'
          : organizationState?.country || usaStateListWithCodes?.[0]?.country,
      line: [
        organizationState?.addressLine1 || '',
        organizationState?.addressLine2 || '',
      ],
      postalCode: organizationState?.postalCode?.display,
      state: organizationState?.state?.code || usaStateListWithCodes?.[0]?.code,
      type: 'postal',
      use: 'work',
    };

    let identifierNIIPObj = {
      use: 'usual',
      type: {
        coding: [
          {
            system: 'http://valueset.example.com',
            code: 'NIIP',
            userSelected: false,
          },
        ],
      },
      system: 'http://valueset.example.com',
      value: apexObject?.code,
    };

    let identifierNPIObj = {
      use: 'usual',
      type: {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
            code: selectedVersion === 'IN' ? 'NMC' : 'NPI',
            userSelected: false,
          },
        ],
      },
      system: 'http://hl7.org/fhir/sid/us-ssn',
      value:
        selectedVersion === 'IN'
          ? organizationState?.nmcNumber
          : organizationState?.npiNumber,
    };
    let telecom = [
      {
        system: 'phone',
        use: 'work',
        value: organizationState?.workNumber,
      },
      {
        system: 'email',
        use: 'work',
        value: organizationState?.email,
      },
    ];

    const typeType = props?.isInsurance
      ? [
          {
            coding: [{ code: 'ins', display: 'Insurance Company' }],
          },
        ]
      : props?.managingOrg
      ? [
          {
            coding: [
              {
                code: 'bus',
                display: 'Non-Healthcare Business or Corporation',
              },
            ],
          },
        ]
      : [
          {
            coding: [{ code: 'prov', display: 'Healthcare Provider' }],
          },
        ];

    let payload = {
      resourceType: 'Organization',
      active: true,
      type: typeType,
      name: props?.isInsurance
        ? apexObject?.display
        : organizationState?.organizationName,
      identifier: [props?.isInsurance ? identifierNIIPObj : identifierNPIObj],
      telecom,
      address: [addressWork],
    };

    return payload;
  };

  // useEffect(() => {
  //   setOrganizationState({
  //     ...organizationState,
  //     state: undefined,
  //     postalCode: undefined,
  //   });
  //   setOrganizationStatesList(
  //     GET_STATES(organizationState?.country?.slice(0, 2)?.toUpperCase())
  //   );
  // }, [organizationState?.country]);

  const countryValidation = {
    name: 'country',

    value: organizationState?.country?.slice(0, 2)?.toUpperCase() || 'US',
    label: 'Country',
    ref: countryRef,
    width: '100%',
    // optionsList: GET_COUNTRIES(),
    optionsList: [
      selectedVersion == 'IN'
        ? { code: 'IN', display: 'India' }
        : // : { code: 'usa', display: 'USA' },
          { code: 'US', display: 'USA' },
    ],
    validation: {
      required: true,
    },
  };

  const handleOnClick = async event => {
    let type = 'info';
    let message = '';
    let description = '';
    const { name } = event?.target;
    if (name === 'create') {
      debugger;
      const orgNameValid = organizationNameRef?.current?.onValidate();
      const apexNameValid = apexNameRef?.current?.onValidate();
      const apexPayerIdValid = apexPayerIdRef?.current?.onValidate();
      const validateObject = selectedVersion === 'IN' ? nmcRef : npiRef;
      const npiValid = validateObject?.current?.onValidate();
      const workNumberValid = workNumberRef?.current?.onValidate();
      const addressLineValid = addressLine1Ref?.current?.onValidate();
      const cityValid = cityRef?.current?.onValidate();
      const stateValid = stateRef?.current?.onValidate();
      const postalcodeValid = postalcodeRef?.current?.onValidate();
      const emailValid = emailRef?.current?.onValidate();
      const countryValid = countryRef?.current?.onValidate();

      const commonNpiValidation = npiValid?.valid
        ? npiValid?.valid
        : apexPayerIdValid?.isValid;

      const commonNameValidation = orgNameValid?.valid
        ? orgNameValid?.valid
        : apexNameValid?.isValid;

      if (
        !commonNameValidation ||
        !(props?.managingOrg || commonNpiValidation) ||
        !workNumberValid?.valid ||
        !addressLineValid?.valid ||
        !cityValid?.valid ||
        !stateValid?.isValid ||
        !postalcodeValid?.isValid ||
        !countryValid?.valid ||
        !emailValid?.valid
      ) {
        return;
      }

      const payload = generateOrganizationFHIRObject();
      try {
        reduxDispatch(setProgress(true));
        const response = await ehrAPIBaseService.post(
          `fhir/createResource`,
          payload
        );

        message = 'Organization Created Successfully';
        description = ` Organization Created Successfully`;
        reduxDispatch(
          quickAddData({
            ...quickData,
            display: response?.data?.name,
            label: response?.data?.name,
            value: `${response?.data?.resourceType}/${response?.data?.id}`,
            code: `${response?.data?.resourceType}/${response?.data?.id}`,
            raw: response.data,
          })
        );

        //   ref.current.getQuickAddData({
        //     display: response?.data?.name,
        //     label: response?.data?.name,
        //     value: `${response?.data?.resourceType}/${response?.data?.id}`,
        //     code: `${response?.data?.resourceType}/${response?.data?.id}`,
        //     raw: response.data,
        // });
        if (typeof props?.setRefresh === 'function') {
          props?.setRefresh(!props?.refresh);
        }
        // dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      } catch (e) {
        console.error(e);
        type = 'error';
        message = 'Error in creating Organization';
        description = 'Error in creating Organization ';
      } finally {
        reduxDispatch(setProgress(false));
        generateNotifications({
          title: message,
          descriptions: description,
          enqueueSnackbar,
          closeSnackbar,
          reduxDispatch,
        });
        if (props?.handleQuickAddClose) {
          props?.handleQuickAddClose();
        } else {
          dispatch({
            type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
          });
        }
        // dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      }
    }
  };

  return (
    <Grid container spacing={2}>
      {props?.isInsurance ? (
        <Grid item sm={12}>
          <AutoCompleteWithTopLabel
            {...apexNameAutoCompleteValidationObject}
            onChange={event => {
              const { name, value } = event?.target;
              setApexObject(value);
            }}
            disableClearable
          />
        </Grid>
      ) : (
        <Grid item sm={12}>
          <TextFieldWithTopLabelComponent
            onChange={handleOnChange}
            {...organizationNameValidationObject}
          />
        </Grid>
      )}

      {props?.isInsurance ? (
        <Grid item sm={12}>
          <AutoCompleteWithTopLabel
            {...payerIdAutoCompleteValidationObject}
            onChange={event => {
              const { name, value } = event?.target;
              setApexObject(value);
            }}
            disableClearable
          />
        </Grid>
      ) : (
        !props?.managingOrg && (
          <Grid item sm={12}>
            <TextFieldWithTopLabelComponent
              onChange={handleOnChange}
              {...ValidationObject1(selectedVersion)}
            />
          </Grid>
        )
      )}

      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...workNumberValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...addressLine1ValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...addressLine2ValidationObject}
        />
      </Grid>

      <Grid item sm={12}>
        <SelectWithTopLabelComponent
          onChange={handleOnChange}
          {...countryValidation}
        />
      </Grid>

      <Grid item sm={12}>
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          {...stateValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...cityValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          from={'practitionerCreate'}
          {...postalCodeValidationObject}
          of={props?.of}
          organizationState={organizationState}
          // forOnly={'fhirOrganizationQuickAdd'}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...emailValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <Button
          fullWidth
          name="create"
          onClick={handleOnClick}
          variant="outlined"
        >
          Create Organization
        </Button>
      </Grid>
      <Grid item sm={12}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          onClick={() => {
            if (props?.handleQuickAddClose) {
              props?.handleQuickAddClose();
            } else {
              dispatch({
                type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
              });
            }
          }}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

export default FHIROrganizationQuickAdd;
